export default __webpack_public_path__ + "media/zurb/img/home/indiana-university-online-5ab1bbac0c3d20bcaba6e821fa55993d.webp";